import React, { Component } from 'react';
import classnames from 'classnames';
import { ClassifyContainer } from './style';
import {objDeepCopy,BUSINESS_INFO} from '../../../utils/tool';
import {observer} from 'mobx-react';
import InfoService from '../../../services/InfoService'

@observer
class ClassifyItem extends Component {
  constructor( props ) {
    super(props);
    const {ClassifyItemPromotion} = this.props.store;
    if (ClassifyItemPromotion) {
      this.state = ClassifyItemPromotion;
    } else {
      this.state = {
        items: []
      }
    }
  }

  componentDidMount() {
    const {ClassifyItemPromotion} = this.props.store;
    if(!ClassifyItemPromotion){
      this.setClassifyItems()
    }
  }

  setClassifyItems=()=>{
    const publishSourceMap = {
      2: BUSINESS_INFO.HAIGUANANDZF.code,
      4: BUSINESS_INFO.ZICHAN.code,
      5: BUSINESS_INFO.POCHAN.code
    }
    InfoService.getCategoryByPublishSource({"publishSource": publishSourceMap[this.props.store.auctionType] || BUSINESS_INFO.ZICHAN.code}).then(res=>{
      if(res && res.datas && res.datas.length>0){
        let assetPromotionClassify = [
          {
            name: '不限',
            param: 0,
            selected: true,
            condition: {categoryIds: 'none'},
          },
        ]
        for(let i=0;i<res.datas.length;i++){
          const {name,id,thirdCateIds} = res.datas[i]
          let obj = {
            name,
            param:id,
            selected:false,
            condition: {categoryIds: thirdCateIds},
          }
          assetPromotionClassify.push(obj)
        }
        this.setState({
          items: objDeepCopy(assetPromotionClassify),
        })
      }
    })
  }

  handleClick = (item) => {
    let curItem = {};
    const {items} = this.state;
    items.forEach((value, index) => {
      value.selected = false;
      if (index === item.index) {
        value.selected = true;
        curItem = value;
      }
    })
    this.setState({
      items,
    });

    // 暂存数据
    const {saveCurrData, addCondition} = this.props.store;
    const { closeFilter, defaultIndex, changeCurrFilterItems  } = this.props;
    saveCurrData('ClassifyItemPromotion', this.state);

    // 增加选择条件
    addCondition(curItem.condition, true);
    closeFilter();
    changeCurrFilterItems(defaultIndex, item.name);
  }

  render() {
    const {items} = this.state;
    return (
      <ClassifyContainer>
       <div className="classify-content">
         {
           items && items.length>0 && items.map((item, index) => {
             return (
               <div
                 key={item.name}
                 className={classnames(["classify-item", {
                   'actived': item.selected,
                 }])}
                 onClick={() => {
                   this.handleClick({
                     index,
                     id: item.param,
                     name: item.name,
                   })
                 }}
               >{item.name}</div>
             )
           })
         }
       </div>
      </ClassifyContainer>
    );
  }
}

export default ClassifyItem;
